import { MessageIcon } from "staysure-component-library";

import QuestionDescriptionDrawer from "@/app/shared-components/question-description/drawer/drawer";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { Agent } from "@/components/molecules/cta-button/cta-buttons";
import styles from "@/components/molecules/question-detail-section/question-detail-section.module.css";
import { showMessenger } from "@/utils/cxone.utils";

import Body from "./body";
import Title from "./title";
import { useCruiseContext } from "../../provider/cruise.provider";

export default function DescriptionContent() {
  const {
    isDrawerOpen,
    selectedAnswer,
    groupedMagnoliaData,
    setIsDrawerOpen,
    magnoliaData,
  } = useCruiseContext();
  const { drawerData } =
    groupedMagnoliaData[selectedAnswer]?.descriptionSection ?? {};

  const { chatButtonLabel } = magnoliaData.overlayArea[0];

  const { wizard } = useWizard();
  const { productSpecialFeatures } = wizard;
  const showNewChatButton = productSpecialFeatures?.showNewChatButton;

  return (
    <div className="flex flex-col-reverse md:flex-col h-full">
      <div className="flex-1 flex items-center justify-center">
        <section className="mt-spacing-m md:mt-0 px-spacing-l md:px-spacing-xxxl">
          <div className=" lg:max-w-[325px] md:max-w-[432px] mx-auto">
            <QuestionDescriptionDrawer
              drawerData={drawerData}
              isDrawerOpen={isDrawerOpen}
              setIsDrawerOpen={setIsDrawerOpen}
            />
            <Title />
            <Body />
          </div>
        </section>
      </div>

      {showNewChatButton && (
        <div
          className={`w-full flex justify-center md:mt-spacing-m mt-auto ${styles.agentButton}`}
        >
          <Agent
            label={chatButtonLabel ?? "Not sure? Chat with us"}
            hierarchy="secondary"
            className="w-[275px] md:w-[300px] h-[56px] px-spacing-l py-spacing-s [&:hover_path]:stroke-interactive-secondary-default"
            rightIcon={
              <span style={{ marginLeft: "4px" }}>
                <MessageIcon stroke="white" fill="white" />
              </span>
            }
            isRightIcon
            semanticColor="Dark Background"
            onClick={() => {
              if (typeof window !== "undefined") {
                showMessenger();
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
